// 模拟API服务
// 当前站点先使用本地真实内容源，避免页面回落到空壳占位数据

export interface DramaScript {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  duration: number;
  genre: string;
  tags: string[];
  script: {
    scenes: Scene[];
  };
  createdAt: string;
  views: number;
  likes: number;
}

export interface Scene {
  id: string;
  title: string;
  duration: number;
  setting: string;
  dialogue: Dialogue[];
}

export interface Dialogue {
  character: string;
  text: string;
  emotion: string;
  choices?: Choice[];
}

export interface Choice {
  id: string;
  text: string;
  nextScene?: string;
  consequence: string;
}

export const dramaCatalog: DramaScript[] = [
  {
    id: '1',
    title: '时间胶囊',
    description: '女生在整理遗物时发现能回到母亲青春时代的时间胶囊，每次打开都能改写一段关系，却也会抹去自己现在拥有的一部分记忆。',
    thumbnail: '/api/placeholder/800/450',
    duration: 320,
    genre: '科幻',
    tags: ['时间旅行', '亲情', '悬念'],
    script: {
      scenes: [
        {
          id: 'scene1',
          title: '阁楼里的旧铁盒',
          duration: 80,
          setting: '老宅阁楼，傍晚的灰尘里透进一束光',
          dialogue: [
            {
              character: '艾米',
              text: '外婆说谁都别碰这个铁盒，可它上面居然刻着我的名字。',
              emotion: '迟疑'
            },
            {
              character: '外婆录音',
              text: '如果你真的打开了它，说明你已经开始后悔一些来不及说出口的话。',
              emotion: '沉重'
            },
            {
              character: '艾米',
              text: '妈走之前我们还在冷战，如果这个东西真能让我回去，我至少想知道她年轻时到底经历了什么。',
              emotion: '克制'
            }
          ]
        },
        {
          id: 'scene2',
          title: '第一次回到1987',
          duration: 80,
          setting: '1987年的录像厅门口，霓虹闪烁，人群嘈杂',
          dialogue: [
            {
              character: '年轻的苏岚',
              text: '你一直跟着我做什么？再跟，我就喊人了。',
              emotion: '戒备'
            },
            {
              character: '艾米',
              text: '我只是想提醒你，今晚别去码头。',
              emotion: '着急'
            },
            {
              character: '年轻的苏岚',
              text: '可我如果不去，我弟弟就凑不齐手术费。你到底是谁？',
              emotion: '怀疑'
            }
          ]
        },
        {
          id: 'scene3',
          title: '被改写的餐桌',
          duration: 80,
          setting: '回到现在的餐厅，墙上的全家福少了一个人',
          dialogue: [
            {
              character: '艾米',
              text: '等等，为什么照片里没有外婆？我只是阻止了妈去码头而已。',
              emotion: '震惊'
            },
            {
              character: '邻居阿姨',
              text: '你今天怎么怪怪的？你外婆二十年前就搬走了，你忘了？',
              emotion: '诧异'
            },
            {
              character: '艾米',
              text: '不是我忘了，是这个家真的变了。',
              emotion: '慌乱',
              choices: [
                {
                  id: 'capsule-choice-1',
                  text: '继续回到过去，追查母亲去码头的真正原因',
                  nextScene: 'scene4',
                  consequence: '艾米决定冒险再次打开时间胶囊，哪怕现实会继续被改写'
                },
                {
                  id: 'capsule-choice-2',
                  text: '先留在现在，调查被抹去的人生痕迹',
                  nextScene: 'scene4',
                  consequence: '艾米开始在现实里寻找被自己忽略的线索'
                }
              ]
            }
          ]
        },
        {
          id: 'scene4',
          title: '母亲留下的第二把钥匙',
          duration: 80,
          setting: '旧出租屋门口，暴雨夜，门缝里塞着一封泛黄信纸',
          dialogue: [
            {
              character: '艾米',
              text: '原来妈不是想逃走，她是在替外婆顶罪……',
              emotion: '哽咽'
            },
            {
              character: '外婆录音',
              text: '别再替我们重写过去了，真正该被改写的，是你以为我们不爱你的误会。',
              emotion: '温柔'
            },
            {
              character: '艾米',
              text: '如果只能留下一个版本，我想留下那个她终于能亲口说爱我的版本。',
              emotion: '坚定'
            }
          ]
        }
      ]
    },
    createdAt: '2026-04-10',
    views: 18580,
    likes: 1392
  },
  {
    id: '2',
    title: '咖啡馆的邂逅',
    description: '加班到失控的品牌策划在一家只营业到午夜的咖啡馆遇见嘴硬店主，两人从借用店面开始合作，逐步揭开一段共同经历过的旧事。',
    thumbnail: '/api/placeholder/800/450',
    duration: 280,
    genre: '爱情',
    tags: ['都市', '治愈', '暧昧'],
    script: {
      scenes: [
        {
          id: 'scene1',
          title: '午夜最后一杯',
          duration: 70,
          setting: '深夜咖啡馆，收银台只亮着一盏暖黄灯',
          dialogue: [
            {
              character: '许棠',
              text: '麻烦来杯最苦的，不加糖，我今晚还得把方案救回来。',
              emotion: '疲惫'
            },
            {
              character: '周叙',
              text: '最苦的不是咖啡，是你明知道撑不住还不肯停。',
              emotion: '平静'
            },
            {
              character: '许棠',
              text: '那你给我一杯能把人从崩溃边缘拉回来的。',
              emotion: '倔强'
            }
          ]
        },
        {
          id: 'scene2',
          title: '临时借来的拍摄场地',
          duration: 70,
          setting: '咖啡馆二楼，品牌拍摄临时搭景',
          dialogue: [
            {
              character: '许棠',
              text: '客户临时改需求，我借你店半天，价钱你开。',
              emotion: '着急'
            },
            {
              character: '周叙',
              text: '不用开价，你把墙上那张旧照片拍进去就行。',
              emotion: '试探'
            },
            {
              character: '许棠',
              text: '这张照片里的女孩……怎么有点像我大学时最好的朋友？',
              emotion: '疑惑'
            }
          ]
        },
        {
          id: 'scene3',
          title: '被压住的旧误会',
          duration: 70,
          setting: '咖啡馆后巷，拍摄收工后只剩两个人',
          dialogue: [
            {
              character: '周叙',
              text: '那年毕业典礼，你是不是根本没看到她留给你的信？',
              emotion: '低沉'
            },
            {
              character: '许棠',
              text: '什么信？她不是一句解释都没留就出国了吗？',
              emotion: '震惊'
            },
            {
              character: '周叙',
              text: '她没出国，她在手术室门口陪了你爸一整夜。',
              emotion: '克制',
              choices: [
                {
                  id: 'coffee-choice-1',
                  text: '追问那封信为什么会消失',
                  nextScene: 'scene4',
                  consequence: '许棠决定查清这段被人刻意截断的友情'
                },
                {
                  id: 'coffee-choice-2',
                  text: '先把拍摄救完，再回来问清真相',
                  nextScene: 'scene4',
                  consequence: '许棠压住情绪，决定先守住眼前的工作'
                }
              ]
            }
          ]
        },
        {
          id: 'scene4',
          title: '店门口的那句留下来',
          duration: 70,
          setting: '清晨五点的街口，店门准备开张前',
          dialogue: [
            {
              character: '许棠',
              text: '原来你早就知道全部，却一直没说。',
              emotion: '复杂'
            },
            {
              character: '周叙',
              text: '我怕你知道以后会走得更快，可现在我更怕你再错过一次。',
              emotion: '坦白'
            },
            {
              character: '许棠',
              text: '那这次你别只递咖啡，直接说，想不想让我留下来。',
              emotion: '试探'
            }
          ]
        }
      ]
    },
    createdAt: '2026-04-11',
    views: 16200,
    likes: 1286
  },
  {
    id: '3',
    title: '古风探案',
    description: '新上任的女仵作和表面吊儿郎当的县令搭档查一桩戏班命案，越查越发现死者并非唯一受害者，整座县城都在替一桩旧案遮掩。',
    thumbnail: '/api/placeholder/800/450',
    duration: 340,
    genre: '悬疑',
    tags: ['古代', '探案', '反转'],
    script: {
      scenes: [
        {
          id: 'scene1',
          title: '戏台坠尸',
          duration: 85,
          setting: '县城戏台后台，锣鼓声刚停，众人四散',
          dialogue: [
            {
              character: '班主',
              text: '官爷，阿九刚还在台上唱，怎么一下台就断气了！',
              emotion: '惊慌'
            },
            {
              character: '沈清禾',
              text: '她脖颈没有勒痕，真正的死因在袖口里藏着。',
              emotion: '冷静'
            },
            {
              character: '陆昭',
              text: '新来的女仵作，第一天就敢在我前面下结论？有点意思。',
              emotion: '玩味'
            }
          ]
        },
        {
          id: 'scene2',
          title: '戏服上的香灰',
          duration: 85,
          setting: '义庄验尸房，灯火摇晃，案台上摆着被剪开的戏服',
          dialogue: [
            {
              character: '沈清禾',
              text: '这不是普通香灰，是供奉旧戏神位时才会用的沉檀灰。',
              emotion: '专注'
            },
            {
              character: '陆昭',
              text: '可旧戏神庙十年前就封了，县里没人敢提那场火。',
              emotion: '收敛'
            },
            {
              character: '沈清禾',
              text: '既然没人敢提，凶手偏偏就想让我们去提。',
              emotion: '判断'
            }
          ]
        },
        {
          id: 'scene3',
          title: '公堂上的第二个名字',
          duration: 85,
          setting: '县衙公堂，百姓围满门口，案卷被摊在桌上',
          dialogue: [
            {
              character: '陆昭',
              text: '死者临死前只写了半个“禾”字，你觉得是在指你？',
              emotion: '试探'
            },
            {
              character: '沈清禾',
              text: '不，她是在提醒我，十年前死在戏神庙里的那个人也姓禾。',
              emotion: '压抑'
            },
            {
              character: '陆昭',
              text: '所以这案子不是冲着阿九，是冲着你来的。',
              emotion: '凝重',
              choices: [
                {
                  id: 'ancient-choice-1',
                  text: '当堂揭开十年前旧案，逼幕后之人现身',
                  nextScene: 'scene4',
                  consequence: '两人选择把旧案重新摆到众人面前'
                },
                {
                  id: 'ancient-choice-2',
                  text: '先放出假线索，引幕后之人主动出手',
                  nextScene: 'scene4',
                  consequence: '陆昭决定先做局，再抓真正的操盘手'
                }
              ]
            }
          ]
        },
        {
          id: 'scene4',
          title: '雨夜戏神庙',
          duration: 85,
          setting: '废弃戏神庙，瓦檐漏雨，旧神位前点着一盏孤灯',
          dialogue: [
            {
              character: '幕后人',
              text: '你们以为我是来灭口，其实我是来替那群装聋作哑的人收债。',
              emotion: '疯狂'
            },
            {
              character: '沈清禾',
              text: '收债不是杀人的借口，但这城里每个沉默的人，确实都欠了死者一句公道。',
              emotion: '坚定'
            },
            {
              character: '陆昭',
              text: '今夜之后，案卷不再封存，人也不再替旧规矩陪葬。',
              emotion: '决断'
            }
          ]
        }
      ]
    },
    createdAt: '2026-04-12',
    views: 14920,
    likes: 1178
  },
  {
    id: '4',
    title: '深夜电台',
    description: '失眠主播接到一通来自三年前的求助电话，她以为自己遇见了恶作剧，直到对方准确说出她未来会失去的东西。',
    thumbnail: '/api/placeholder/800/450',
    duration: 260,
    genre: '悬疑',
    tags: ['深夜来电', '都市', '悬念'],
    script: {
      scenes: [
        {
          id: 'scene1',
          title: '凌晨一点的来电',
          duration: 65,
          setting: '深夜电台直播间，只剩红色录音灯亮着',
          dialogue: [
            {
              character: '主播闻夏',
              text: '今晚最后一通热线，来，说说你最想改掉的一件事。',
              emotion: '职业化'
            },
            {
              character: '神秘来电者',
              text: '如果我说，你三天后会丢掉那枚戒指，你会信吗？',
              emotion: '平静'
            },
            {
              character: '闻夏',
              text: '这枚戒指我从不离身，你到底是谁？',
              emotion: '警惕'
            }
          ]
        },
        {
          id: 'scene2',
          title: '旧录音里的自己',
          duration: 65,
          setting: '节目资料室，堆满编号磁带的狭窄走道',
          dialogue: [
            {
              character: '制作人阿泽',
              text: '这通电话的线路记录不对，它是从三年前被封掉的旧机房拨进来的。',
              emotion: '困惑'
            },
            {
              character: '闻夏',
              text: '更离谱的是，这段声音像极了三年前的我。',
              emotion: '紧绷'
            },
            {
              character: '阿泽',
              text: '如果真是你自己打来的，那你想提醒现在的你什么？',
              emotion: '压低声音'
            }
          ]
        },
        {
          id: 'scene3',
          title: '广播塔上的真相',
          duration: 65,
          setting: '停用广播塔顶层，风很大，地上散着旧节目单',
          dialogue: [
            {
              character: '闻夏',
              text: '原来三年前失踪的不是热线记录，是那晚真正接电话的人。',
              emotion: '震动'
            },
            {
              character: '阿泽',
              text: '你想起来了？那晚你不是没去，是你被人刻意带离现场。',
              emotion: '沉重'
            },
            {
              character: '闻夏',
              text: '所以那通来自过去的电话，是想逼我回到没敢面对的那一夜。',
              emotion: '醒悟'
            }
          ]
        },
        {
          id: 'scene4',
          title: '下一通热线已经响起',
          duration: 65,
          setting: '重新开播的直播间，红灯再次亮起',
          dialogue: [
            {
              character: '闻夏',
              text: '欢迎回来，今晚我不再替任何人把真相剪掉。',
              emotion: '坚定'
            },
            {
              character: '新来电者',
              text: '那你也准备好听下一件事了吗？你以为已经结束的人，还活着。',
              emotion: '神秘'
            },
            {
              character: '闻夏',
              text: '接进来，这次我亲自听完。',
              emotion: '决心'
            }
          ]
        }
      ]
    },
    createdAt: '2026-04-13',
    views: 9800,
    likes: 812
  },
  {
    id: '5',
    title: '合同恋人',
    description: '为了拿下品牌代言，女明星和危机公关顾问签下一纸假恋爱合约，却在处理一次次舆论危机时，把彼此最不肯示人的伤口都看见了。',
    thumbnail: '/api/placeholder/800/450',
    duration: 300,
    genre: '现代',
    tags: ['娱乐圈', '合约', '甜虐'],
    script: {
      scenes: [
        {
          id: 'scene1',
          title: '合约第一条',
          duration: 75,
          setting: '经纪公司会议室，墙上滚动着负面热搜',
          dialogue: [
            {
              character: '苏澄',
              text: '所以你们要我跟一个不认识的人假装恋爱，来洗掉热搜？',
              emotion: '压火'
            },
            {
              character: '顾时宴',
              text: '不是假装，是在镜头前维持可信关系。期限三十天，边界我来定。',
              emotion: '冷静'
            },
            {
              character: '苏澄',
              text: '边界最好定清楚，我最讨厌别人替我决定人生。',
              emotion: '锋利'
            }
          ]
        },
        {
          id: 'scene2',
          title: '第一次营业翻车',
          duration: 75,
          setting: '品牌活动后台，闪光灯声不断，工作人员来回穿梭',
          dialogue: [
            {
              character: '主持人',
              text: '两位第一次公开同框，谁先心动的？',
              emotion: '八卦'
            },
            {
              character: '顾时宴',
              text: '她先心动，因为我出现得比公关方案更及时。',
              emotion: '从容'
            },
            {
              character: '苏澄',
              text: '你这句玩笑再说慢一点，明天热搜就是我们当场翻脸。',
              emotion: '咬牙'
            }
          ]
        },
        {
          id: 'scene3',
          title: '被删掉的旧采访',
          duration: 75,
          setting: '保姆车里，窗外是散场后的雨夜',
          dialogue: [
            {
              character: '苏澄',
              text: '你为什么会知道我最怕别人提我爸？那段采访公司已经全网删了。',
              emotion: '防备'
            },
            {
              character: '顾时宴',
              text: '因为当年帮你压掉那条采访的人，就是我。',
              emotion: '坦白'
            },
            {
              character: '苏澄',
              text: '所以你不是刚出现，你是看着我一路被推上来的那个人。',
              emotion: '失神',
              choices: [
                {
                  id: 'contract-choice-1',
                  text: '继续合作，但要求他交代当年的全部真相',
                  nextScene: 'scene4',
                  consequence: '苏澄选择把合约延长，但条件是顾时宴必须不再隐瞒'
                },
                {
                  id: 'contract-choice-2',
                  text: '立刻终止合约，自己去扛接下来的舆论',
                  nextScene: 'scene4',
                  consequence: '苏澄准备把掌控权抢回来，哪怕代价更大'
                }
              ]
            }
          ]
        },
        {
          id: 'scene4',
          title: '发布会上的真话',
          duration: 75,
          setting: '媒体发布会现场，台下全是镜头，气氛几乎凝固',
          dialogue: [
            {
              character: '顾时宴',
              text: '今天不聊恋情炒作，我只说一件事，当年那条采访是我做主删的，责任在我。',
              emotion: '决绝'
            },
            {
              character: '苏澄',
              text: '你替我挡过一次，但以后我不想再躲在别人身后。我们可以一起面对。 ',
              emotion: '坚定'
            },
            {
              character: '记者',
              text: '那你们现在到底是真情侣还是假合约？',
              emotion: '追问'
            }
          ]
        }
      ]
    },
    createdAt: '2026-04-14',
    views: 12140,
    likes: 934
  }
];

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const dramaApi = {
  getAllDramas: async (): Promise<DramaScript[]> => {
    await delay(250);
    return [...dramaCatalog];
  },

  getDramaById: async (id: string): Promise<DramaScript | null> => {
    await delay(180);
    return dramaCatalog.find(drama => drama.id === id) || null;
  },

  getDramasByGenre: async (genre: string): Promise<DramaScript[]> => {
    await delay(220);
    return dramaCatalog.filter(drama => drama.genre === genre);
  },

  searchDramas: async (query: string): Promise<DramaScript[]> => {
    await delay(260);
    const lowerQuery = query.toLowerCase();
    return dramaCatalog.filter(drama =>
      drama.title.toLowerCase().includes(lowerQuery) ||
      drama.description.toLowerCase().includes(lowerQuery) ||
      drama.tags.some(tag => tag.toLowerCase().includes(lowerQuery))
    );
  },

  getPopularDramas: async (limit: number = 6): Promise<DramaScript[]> => {
    await delay(220);
    return [...dramaCatalog]
      .sort((a, b) => b.views - a.views)
      .slice(0, limit);
  },

  updateViews: async (id: string): Promise<void> => {
    await delay(120);
    const drama = dramaCatalog.find(item => item.id === id);
    if (drama) {
      drama.views += 1;
    }
  },

  updateLikes: async (id: string, increment: boolean): Promise<void> => {
    await delay(120);
    const drama = dramaCatalog.find(item => item.id === id);
    if (drama) {
      drama.likes += increment ? 1 : -1;
    }
  }
};

export default dramaApi;
